import type { AnonymouseReckonUserAttributes } from './types';

export function createAnonymousUser(): AnonymouseReckonUserAttributes {
  const host = typeof window === 'undefined' ? 'unknow' : window.location.host;

  return { anonymous: true, host };
}
